module.exports = __webpack_public_path__ + "img/INTERIOR-CIAZ-1.c0ee2387.jpg";